<template>
  <div>
    <div class="mb-5">
      <base-card overflowVisible :title="$t('cycleControl')" :info="tooltipText" @rightBtnClick="showAddSection = true" :hideButtons="historyReadOnly">

      <template v-if="!showAddSection" :slot="$uiHelpers.isMobile || $uiHelpers.isTablet ? 'append-btn-title' : 'right-button'">
          <add-button :buttonText="$t('new-cycle')" @click="addNewCycleForm"></add-button>
        </template>
        <!-- Formulario para iniciar un nuevo ciclo -->
        <form v-if="showAddSection" @submit.prevent="addNewCycleForm" class="d-flex flex-column flex-md-row align-items-start form-section">
          <span v-if="!allowAdd">{{ $t('mustSetPeriod') }}</span>
            <b-col v-if="allowAdd" cols="12" md="3" class="mb-2 mb-md-0 mx-md-2">
            <base-datepicker :max="new Date()" :placeholder="$t('cycleStartDate')" v-model="startDate" value-as-date></base-datepicker>
            <span class="add-text" @click="() => showAddSection = false">{{ $t('back') }}</span>
          </b-col>

          <!-- Botón de comenzar ciclo -->
          <b-col v-if="allowAdd" cols="12" class="d-flex justify-content-md-start justify-content-center">
            <button class="btn btn-primary" type="submit" :disabled="!startDate">{{ $t('startCycle') }}</button>
          </b-col>

        </form>
        <!-- Historial de ciclos -->
        <div v-if="cycles.length > 0" class="results mt-4">
          <ul class="cycle-item">
            <h4>{{ $t('historyCycle') }}</h4>
            <li v-for="(cycle) in cycles" :key="cycle.idCycle" class="cycle-card">
              <strong>{{ $t('cycle') }} {{ cycle.cycleDuration ? formatDate(cycle.dateStartCycle) : $t('current') + ' ' + formatDate(cycle.dateStartCycle)}} {{cycle.cycleDuration != null ? $t('until') + ' ' + formatDate(addDaysToDate(cycle.dateStartCycle, cycle.cycleDuration)) : '' }}</strong>
              <br />
              <!-- Mostrar duración del ciclo si está finalizado -->
              <span v-if="cycle.cycleDuration">{{ $t('cycleDuration2') }}: {{ cycle.cycleDuration }} {{ $t('days') }}</span>
              <div v-if="cycle.periodDuration">
              <span>{{ $t('periodDuration2') }}: {{ cycle.periodDuration }} {{ $t('days') }}</span>
              </div>

              <!-- Si es el ciclo en curso, mostrar opción de finalizar o establecer duración del periodo -->
              <div v-else>
                <span v-if="!visibleSetPeriod" class="btn btn-secondary btn-background" @click="setVisiblePeriodLength()">{{ $t('setPeriodDuration') }}</span>
                <div v-else>
                  <b-col cols="12" md="3" class="mb-2 mb-md-0 mx-md-2 input-container">
                    <base-input min="0" class="inputAnswer" type="number" v-model="periodDuration" :placeholder="$t('periodDuration2')">
                      <template slot="append">
                        <span class="days-text">{{ $t('days') }}</span>
                      </template>
                    </base-input>
                    <span class="add-text" @click="setPeriodDuration(cycle)">{{ $t('add-txt') }}</span>
                  </b-col>
                </div>
              </div>
              <div v-if="cycle.cycleDuration">
                {{ $t('ovulationDuration') }}: {{ calculateOvulationMonthDays(cycle.dateStartCycle, cycle.cycleDuration).join(', ') }}
              </div>
              <div v-else>
                <div>{{ $t('ovulationDurationPrediction') }}: {{ displayFertileDays() }}</div>
                <div>{{ $t('newCyclePredictionDate') }}: {{ formatDate(newCyclePrediction) }}</div>

              </div>
              <CycleChart
                :startDate="cycle.dateStartCycle"
                :cycleLength="cycle.cycleDuration"
                :predictedCycleLength="calculateAverageCycleLength()"
                :periodLength="cycle.periodDuration"
              />
              <span class="delete-text" @click="deleteCycle(cycle.idCycle)">{{ $t('delete') }}</span>
            </li>
          </ul>
        </div>
        <div v-else class="no-cycles">
          <p>{{$t('noControl')}}</p>
        </div>
        <base-dialog v-model="visibleEndCurrentCycle" :content="$t('confirmEndCurrentCycle')" :okFn="async () => { endCurrentCycle() }" :cancelFn="() => { visibleEndCurrentCycle = false }"></base-dialog>
 
      </base-card>
    </div>
  </div>
</template>

<script>
import CycleChart from './CycleChart.vue'
import patientsRepository from '@/repositories/PatientsRepository'
import { MENU_PATH } from '@/constants/clinicHistory'
import clinicHistoryMixin from '@/mixins/clinicHistory.mixin'
import AddButton from '@/components/base/buttons/AddButton'
import BaseDatepicker from '@/components/base/forms/BaseDatepicker'
import BaseDialog from '@/components/base/BaseDialog'
import moment from 'moment'
import { appointmentDateFormat } from '@/helpers/date.helpers'

export default {
  name: 'menstrual-calendar',
  components: {
    CycleChart,
    BaseDialog,
    AddButton,
    BaseDatepicker
  },
  mixins: [clinicHistoryMixin],
  data () {
    return {
      startDate: '',
      MENU_PATH,
      visibleEndCurrentCycle: false,
      confirmEnd: false,
      allowAdd: false,
      visibleSetPeriod: false,
      showAddSection: false,
      cycles: [],
      currentCycle: null,
      mostRecentCycle: null,
      newCyclePrediction: null,
      periodDuration: null
    }
  },
  computed: {
    tooltipText () {
      return `
        <div><span style="display: inline-block;width: 10px;height: 10px;border-radius: 50%;margin-right: 5px;background-color: red"></span> ${this.$t('periodDuration2')}</div>
        <div><span style="display: inline-block;width: 10px;height: 10px;border-radius: 50%;margin-right: 5px;background-color: orange"></span> ${this.$t('ovulationDurationPrediction')}</div>
        <div><span style="display: inline-block;width: 10px;height: 10px;border-radius: 50%;margin-right: 5px;background-color: lightblue"></span> ${this.$t('ovulationDuration')}</div>
      `
    }
  },
  methods: {
    async getCycles () {
      try {
        const response = await patientsRepository.getMenstruations()
        if (response.data.length > 0) {
        this.cycles = response.data.sort((a, b) => new Date(b.dateStartCycle) - new Date(a.dateStartCycle))
        this.currentCycle = this.cycles.find(cycle => !cycle.cycleDuration && cycle.periodDuration)
        this.mostRecentCycle = this.cycles[0]
        this.allowAdd = this.mostRecentCycle.periodDuration != null
      } else {
        this.allowAdd = true
      }
      } catch (error) {
        this.$store.dispatch('showDangerAlert', this.$t('error-cycles-get'))
      }
      if (this.mostRecentCycle) {
        this.newCyclePrediction = new Date(this.mostRecentCycle.dateStartCycle)
        this.newCyclePrediction.setDate(this.newCyclePrediction.getDate() + this.calculateAverageCycleLength())
      }
    },
    async deleteCycle (idCycle) {
      try {
        const response = await patientsRepository.deleteMenstruation(idCycle)
        if (response.data === true) {
          this.cycles = this.cycles.filter(cycle => cycle.idCycle !== idCycle)
          this.getCycles()
        } else {
          console.error('error')
        }
      } catch (error) {
        this.$store.dispatch('showDangerAlert', this.$t('error-cycles-delete'))
      }
    },
    async setVisiblePeriodLength () {
      this.visibleSetPeriod = true
    },
    async setPeriodDuration (cycle) {
      if (this.periodDuration) {
        try {
          await this.updateCycle({ idCycle: cycle.idCycle, periodDuration: parseInt(this.periodDuration) })
          this.visibleSetPeriod = false
          this.periodDuration = null
          this.getCycles()
        } catch (error) {
          this.$store.dispatch('showDangerAlert', this.$t('error-cycles-set'))
        }
      }
    },
    addDaysToDate (dateString, days) {
      const date = new Date(dateString)
      date.setDate(date.getDate() + days - 1)
      return date
    },
    clickToVisiblePeriod () {
      this.visibleSetPeriod = true
    },
    async addNewCycleForm () {
      if (this.currentCycle) {
        this.visibleEndCurrentCycle = true
      } else {
        this.startNewCycle()
      }
      this.showAddSection = true
    },
    async startNewCycle () {
      const newCycle = {
        dateStartCycle: new Date(this.startDate).toISOString()
      }
      try {
        await patientsRepository.postMenstruation(newCycle)
        this.getCycles() // Recargar los ciclos
        this.startDate = null
        this.showAddSection = false
      } catch (error) {
        this.$store.dispatch('showDangerAlert', this.$t('error-cycles-start'))
      }
    },
    async endCurrentCycle () {
      this.visibleEndCurrentCycle = false
      const newCycleStartDate = moment(this.startDate).startOf('day')
      const currentCycleStartDate = moment(this.currentCycle.dateStartCycle).startOf('day')

      const cycleDuration = newCycleStartDate.diff(currentCycleStartDate, 'days')
      try {
        await this.updateCycle({ idCycle: this.currentCycle.idCycle, cycleDuration: cycleDuration })
        this.currentCycle = null
        await this.startNewCycle()
        this.getCycles()
      } catch (error) {
        this.$store.dispatch('showDangerAlert', this.$t('error-cycles-delete'))
      }
    },
    async updateCycle (updatedCycleData) {
      try {
        await patientsRepository.putMenstruation(updatedCycleData)
        this.getCycles()
      } catch (error) {
        this.$store.dispatch('showDangerAlert', this.$t('error-cycles-set2'))
      }
    },
    formatDate (dateString) {
      return appointmentDateFormat(dateString, true, true)
    },
    calculateOvulationMonthDays (startDate, cycleDuration) {
      const ovulationDay = Math.floor(cycleDuration / 2)
      const ovulationStart = ovulationDay - 3 // restamos 3 y sumamos 2 para obtener seis días que son los que dura la ovulación
      const ovulationEnd = ovulationDay + 2
      let ovulationDays = []
      for (let i = ovulationStart; i <= ovulationEnd; i++) {
        const ovulationDate = new Date(startDate)
        ovulationDate.setDate(ovulationDate.getDate() + i)
        ovulationDays.push(ovulationDate.getDate())
      }
      return ovulationDays
  },
  calculateAverageCycleLength () {
      // Filtrar ciclos finalizados y con duración válida
      const completedCycles = this.cycles.filter(cycle => cycle.cycleDuration)
      if (completedCycles.length === 0) {
        return 27
      }
      const totalDuration = completedCycles.reduce((sum, cycle) => sum + cycle.cycleDuration, 0)
      return Math.round(totalDuration / completedCycles.length)
    },
    displayFertileDays () {
      const cycleDuration = this.calculateAverageCycleLength()
      const fertileDays = this.calculateOvulationMonthDays(this.mostRecentCycle.dateStartCycle, cycleDuration)
      return fertileDays.join(', ')
    }
  },
  mounted () {
    this.getCycles()
  }
}
</script>

<style scoped lang="scss">

.d-flex {
  display: flex;
}
.flex-column {
  flex-direction: column;
}
.flex-md-row {
  flex-direction: row;
}
.align-items-center {
  align-items: center;
}

.cycle-form {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.control-ciclos {
  margin: 20px;
}

form {
  margin-bottom: 20px;
}

.btn-background{
  background-color: transparent !important;
  border-color: transparent !important;
}
.no-cycles {
  margin-top: 20px;
  font-size: 16px;
  color: #888;
  text-align: center;
}

.cycle-item {
  padding: 0;
  margin: 0;
  list-style-type: none;
  @include mobile {
		padding-left: 0;
	}
}
.cycle-card {
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 20px;
  overflow: hidden;
}

.delete-text {
  color: red;
  cursor: pointer;
}

.input-container {
  @include desktop {
    margin: 1rem;
	}
  @include desktop-sm {
    margin: 1rem;
	}
  @include tablets {
    margin: 1rem;
    max-width: 100% !important
	}
  display: flex;
  flex-direction: row;
  align-items: center;
}

.inputAnswer {
  margin-right: 10px;
}

.days-text {
  margin-left: 5px;
}

.add-text {
  margin-left: 10px;
  cursor: pointer;
  color: $blue;
}

.delete-text:hover {
  text-decoration: underline;
}



</style>



// WEBPACK FOOTER //
// src/components/views/clinicHistory/MenstrualCalendar.vue